import { Cellstyle, HotCellNumeric } from "~app/common/components/hot-doc/hotdoc/cell";
import { NumberUtils } from "~app/common/utils/number-utils";

export class MattslagskonverteringNumericStyledHotCell extends HotCellNumeric {
    constructor(value: number, private readonly cellClassList: string[], private readonly extraflags: Cellstyle, onChange: (newValue) => void) {
        super(value, extraflags, onChange, (x) => x);
    }

    static format(value: number): string {
        const val = NumberUtils.isNumeric(value) ? value : 0;
        return val !== 0 ? val.toLocaleString("sv-SE") : "";
    }

    applyCustomStyles(td: HTMLTableCellElement) {
        if (this.cellClassList) {
            td.classList.add(...this.cellClassList);
        }
    }

    validate(value: any): boolean {
        const val = value ? value.toLocaleString("sv-SE").replace(/,/g, "."): null;
        return NumberUtils.isNumeric(val) || !isNaN(val);
    }

    protected genHtml(): string {
        return MattslagskonverteringNumericStyledHotCell.format(this.value);
    }

    protected applyStyle(td: HTMLTableCellElement, cellProperties: any) {
        this.applyCustomStyles(td);
        super.applyStyle(td, cellProperties);
    }
}
